import {
  BarChart3,
  CheckCircle2,
  Clock3,
  Inbox,
  MessageSquareText,
  Search,
  Tags,
  UsersRound,
  Workflow,
} from 'lucide-react';
import { useCountUp } from '../lib/motion';

const tickets = [
  {
    initials: 'MC',
    name: 'Mercúrio Comércio',
    subject: 'Documentos do fechamento mensal',
    tag: 'Fiscal',
    status: 'Em andamento',
    statusClass: 'blue',
  },
  {
    initials: 'AP',
    name: 'Almeida & Prado',
    subject: 'Admissão de novo colaborador',
    tag: 'Pessoal',
    status: 'Novo',
    statusClass: 'cyan',
  },
  {
    initials: 'VS',
    name: 'Vértice Serviços',
    subject: 'Dúvida sobre guia de imposto',
    tag: 'Contábil',
    status: 'Aguardando',
    statusClass: 'neutral',
  },
];

export function DashboardPreview() {
  const attendances = useCountUp(42);
  const pending = useCountUp(11);
  const sla = useCountUp(94);

  return (
    <div className="product-preview" aria-label="Representação ilustrativa do painel ContDesk">
      <div className="preview-caption">
        <span /> Demonstração visual
      </div>

      <div className="preview-window">
        <div className="preview-scan" aria-hidden="true" />
        <aside className="preview-sidebar" aria-hidden="true">
          <img src="/brand/contdesk-mark.svg" alt="" />
          <div className="preview-sidebar-icons">
            <span className="active"><Inbox /></span>
            <span><UsersRound /></span>
            <span><Workflow /></span>
            <span><BarChart3 /></span>
          </div>
          <span className="preview-user">RS</span>
        </aside>

        <div className="preview-main">
          <div className="preview-topbar">
            <div>
              <span className="preview-kicker">Operação contábil</span>
              <strong>Visão dos atendimentos</strong>
            </div>
            <div className="preview-search"><Search /> Pesquisar</div>
          </div>

          <div className="preview-metrics">
            <div>
              <span>Atendimentos hoje</span>
              <strong>{attendances}</strong>
              <small><MessageSquareText /> todos os canais</small>
            </div>
            <div>
              <span>Pendências</span>
              <strong>{pending}</strong>
              <small><Clock3 /> requerem atenção</small>
            </div>
            <div>
              <span>Resolvidos</span>
              <strong>{sla}%</strong>
              <small><CheckCircle2 /> cenário ilustrativo</small>
            </div>
          </div>

          <div className="preview-table">
            <div className="preview-table-head">
              <strong>Fila unificada</strong>
              <span><Tags /> Filtrar</span>
            </div>
            {tickets.map(ticket => (
              <div className="preview-ticket" key={ticket.name}>
                <span className="preview-avatar">{ticket.initials}</span>
                <div className="preview-ticket-copy">
                  <strong>{ticket.name}</strong>
                  <span>{ticket.subject}</span>
                </div>
                <span className="preview-tag">{ticket.tag}</span>
                <span className={`preview-status ${ticket.statusClass}`}>{ticket.status}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="automation-toast">
        <span className="automation-toast-icon"><Workflow /></span>
        <div>
          <small>Distribuição de atendimento</small>
          <strong>Fiscal · Documentos</strong>
          <span>Encaminhado para a fila Fiscal</span>
        </div>
        <CheckCircle2 className="automation-toast-check" />
      </div>
    </div>
  );
}
